<template>
  <component :is="component" :selected-key="selectedKey" :selected-value="selectedValue" />
</template>

<script>
import Base from './Base.vue';
import PmopConfig from '../PmopConfig/index.vue';
import PrimaryDepartment from '../PrimaryDepartment/index.vue';
import BusinessDepartment from '../BusinessDepartment/index.vue';

export default {
  components: { Base, PmopConfig, PrimaryDepartment, BusinessDepartment },
  props: {
    selectedKey: {
      type: String,
      default: ''
    },
    selectedValue: {}
  },
  computed: {
    component() {
      if (this.selectedKey === 'pmom' || this.selectedKey === 'br_po' || this.selectedKey === 'br_technical_manager') {
        return PmopConfig;
      } else if (this.selectedKey === 'primary_department') {
        return PrimaryDepartment;
      } else if (this.selectedKey === 'business_department') {
        return BusinessDepartment;
      } else if (this.selectedKey === 'big_br_po') {
        return PmopConfig;
      }
      return Base;
    }
  }
};
</script>

<style lang="less" scoped></style>
